import { render, staticRenderFns } from "./RegistrationActivationPage.vue?vue&type=template&id=6daa0a38&"
import script from "./RegistrationActivationPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationActivationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports